export const figure18a = {
  chart: {
      type: 'line',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
        height: 230,
      plotBackgroundColor: null,
      plotBorderWidth: null,
    },
    credits: {
      enabled: false
  },
    title: {
      text: 'Géorgie'
    },
    subtitle: {
      text: null
  },
    xAxis: {
      categories: ['2013','2014','2015', '2016','2020',]
    },
    labels: {
      	
      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      },
    },
    yAxis: {
      min: 0,
      max: 15000,
      tickInterval: 5000,
      title: {
          text: null,
      },
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: false
        },
        enableMouseTracking: true
      }
    },
    legend: {
      enabled: false,
  },
    colors: ['#5b9bd5', '#ed7d32','#cbcccb', '#ffc100'],
    series: [{
      name: 'Petites exploitations',
      data: [1604, 1929, 1811, 2972, 1436,]
    }, {
      name: 'Autres exploitations',
      data: [4579, 5737, 5160, 6259, 12522,]
    },{
      name: 'Petites exploitations dirigées par une femme',
      data: [1403, 1683, 1502, 1743, 1079,]
    },{
      name: 'Petites exploitations dirigées par un homme',
      data: [1695, 2044, 1945, 3844, 1630,]
    }]
  }

  